// extracted by mini-css-extract-plugin
module.exports = {"timezonelabelbackground":"ContentTimestamp_timezonelabelbackground__igZH4","timezonelabel":"ContentTimestamp_timezonelabel__djFgZ"};